(function () {
  'use strict';

  angular
  .module('filter.discount', [])

  /* @ngInject */
  .filter('discount', ["AppService", function (AppService) {
    var params = null;

    function discountFilter(value) {
      if (value === null) return value;

      if (params !== null) {
        return !angular.isFunction(params.then) ? getDiscountFilter(value) : undefined;
      }
      params = AppService.getParams()
          .then(function (data) {
            params = data;
          })
          .catch(function (error) {
            console.error(error);
          });

    }

    function getDiscountFilter(value) {
      var loc = params.Localization,
          template = loc.DiscountHTMLFormat,
          render = template.replace('[%amount%]', Math.round(value))
                           .replace(',', '##DiscountTSep##')
                           .replace('.', loc.DiscountDecimalSeparator)
                           .replace('##DiscountTSep##', loc.DiscountThousandSeparator);
      return render;
    }

    discountFilter.$stateful = true;
    return discountFilter;

  }]);

})();
